export default "__VITE_ASSET__f2af96e6__"